__turbopack_context__.v({
  "chatList": "ClientChatList-module__pcye6q__chatList",
  "chatList__search": "ClientChatList-module__pcye6q__chatList__search",
});
